export const HOLIDAY_NOTIFICATION_SHOW_DATES = ["2026-08-07"];
export const HOLIDAY_NON_WORKING_DATES = ["2026-05-28"];

export type HolidayNotificationLanguage = "en" | "am" | "ru";

export const HOLIDAY_SERVICE_ROWS = [
  { id: 1 as const, available: true },
  { id: 2 as const, available: false },
  { id: 3 as const, available: true },
  { id: 4 as const, available: false },
] as const;

const dateLabels = {
  en: {
    "2026-05-28": "May 28",
  },
  am: {
    "2026-05-28": "մայիսի 28-ը",
  },
  ru: {
    "2026-05-28": "28 мая",
  },
} as const;

export const getTodayDateKey = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getHolidayNotificationLanguage = (
  languageCode: string,
): HolidayNotificationLanguage => {
  const code = languageCode.toLowerCase();
  if (code.startsWith("ru")) return "ru";
  if (code.startsWith("hy") || code.startsWith("am")) return "am";
  return "en";
};

export const resolveHolidayNotificationDate = (
  seenByDate: Record<string, boolean>,
  today = getTodayDateKey(),
): string | null => {
  if (!HOLIDAY_NOTIFICATION_SHOW_DATES.includes(today)) {
    return null;
  }

  if (!seenByDate[today]) {
    return today;
  }

  return null;
};

export const getUpcomingHolidayDates = (today = getTodayDateKey()) =>
  HOLIDAY_NON_WORKING_DATES.filter((date) => date >= today);

export const formatHolidayDateList = (
  dates: string[],
  lang: HolidayNotificationLanguage,
) => {
  const labels = dates.map(
    (date) => dateLabels[lang][date as keyof typeof dateLabels.en],
  );
  if (labels.length <= 1) return labels[0] || "";

  const last = labels[labels.length - 1];
  const rest = labels.slice(0, -1).join(", ");
  const conjunction = lang === "ru" ? " и " : " և ";

  if (lang === "en") {
    return `${rest}, and ${last}`;
  }

  return `${rest}${conjunction}${last}`;
};

export const getHolidayDatesSubtitle = (
  upcomingDates: string[],
  lang: HolidayNotificationLanguage,
  translate: (key: string, options?: { dates: string }) => string,
) => {
  const formattedDates = formatHolidayDateList(upcomingDates, lang);
  if (upcomingDates.length === 1) {
    return translate("holidayScheduleDatesLineLast", { dates: formattedDates });
  }
  return translate("holidayScheduleDatesLine", { dates: formattedDates });
};
